import React, { useState } from 'react'
import axios from '../../../library/axios'
import { MySwal } from '../../../library/swal'
import Button from 'react-bootstrap/Button'
import { setHrefWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const FormVerificationManual = (props) => {

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [namaRs, setnamaRs] = useState('')
    const [namaDirektur, setnamaDirektur] = useState('')
    const [emailRs, setemailRs] = useState('')
    const [telpRs, settelpRs] = useState('')
    const [kodeRs, setkodeRs] = useState()
    const [website, setwebsite] = useState('')
    const [alamatRs, setalamatRs] = useState('')
    const [namaDepan, setnamaDepan] = useState('')
    const [namaBelakang, setnamaBelakang] = useState('')
    const [namaPanggilan, setnamaPanggilan] = useState('')
    const [emailPic, setemailPic] = useState('')
    const [hp1, sethp1] = useState('')
    const [hp2, sethp2] = useState('')
    const [gender, setgender] = useState('')

    const handleSubmit = () => {
        setLoading(true)
        setDisabled(true)

        const requestBody = {
            namaRs: namaRs,
            kodeRs: kodeRs,
            direktur: namaDirektur,
            alamat: alamatRs,
            telp: telpRs,
            website: website,
            email: emailRs
        }
        // console.log(requestBody)
        // return false
        axios({
            url: `/profile/create/`,
            method: 'POST',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res.data.id)
                // return false
                if (res.status === 200) {
                    props.close()

                    handleStepFirst()

                    handleUpdateCp(res.data.id)
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    // console.log(err?.response?.statusText)
                    MySwal.fire({
                        icon: 'error',
                        title: `${err?.response?.statusText}`,
                        text: `${err?.response?.data?.message}`
                    })
                }
            })
    }

    const handleUpdateCp = (idProfile) => {

        const requestBody = {
            idProfile: idProfile,
            namaDepan: namaDepan,
            namaBelakang: namaBelakang,
            namaPanggilan: namaPanggilan,
            email: emailPic,
            hp1: hp1,
            hp2: hp2,
            gender: gender,
        }
        // console.log(requestBody)
        // return false
        axios({
            url: `/contact-person/create-contact-person`,
            method: 'POST',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    handleLogin('sa', 'Qwerty123#')

                    setLoading(false)
                    setDisabled(false)
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err?.response?.data?.message)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops, Error!',
                        text: `${err?.response?.data?.message}`
                    })
                }
            })
    }

    const handleStepFirst = async () => {
        try {
            const options = {
                url: `/users/stepFirst`,
                method: 'GET',
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                }
            }
            const { data } = await axios(options)
        } catch (err) {
            console.log(err.message)
        }
    }

    const handleLogin = (username, password) => {

        const requestBody = {
            username: username,
            password: password,
        }

        axios({
            url: '/users/auth',
            method: 'POST',
            data: requestBody
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Validasi Sukses, Mohon Tunggu',
                        text: 'Anda akan di arahkan ke halaman Profile!'
                    })

                    setTimeout(() => {
                        // get token from the result
                        localStorage.setItem(`token${getSlug() ? '-' + getSlug() : ''}`, res?.data?.token);
                        
                        // Determine redirect path based on user role
                        const groupName = res?.data?.groupName || "";
                        let redirectPath = "/profile"; // default redirect
                        
                        if (groupName === "Kelompok Kerja") {
                            redirectPath = "/dashboard-pokja";
                        } else if (groupName === "Surveior Internal") {
                            redirectPath = "/dashboard-internal";
                        } else if (groupName === "Surveior External") {
                            redirectPath = "/accreditation";
                        }
                        
                        setHrefWithSlugHook(redirectPath);
                    }, 3000);

                    setLoading(false)
                    setDisabled(false)
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err.message)
                }
            })
    }

    return (
        <>
            <>
                <div className="mb-5 row">
                    <div className='col-6'>
                        <span className="badge badge-info">Data Rumah Sakit</span>
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="kodeRs" className="col-sm-2 col-form-label required">Kode</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="kodeRs" onChange={(e) => setkodeRs(e.target.value)} value={kodeRs} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="namaRs" className="col-sm-2 col-form-label required">Nama</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="namaRs" onChange={(e) => setnamaRs(e.target.value)} value={namaRs} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="direktur" className="col-sm-2 col-form-label required">Direktur</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="direktur" onChange={(e) => setnamaDirektur(e.target.value)} value={namaDirektur} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="emailRs" className="col-sm-2 col-form-label required">Email</label>
                    <div className="col-sm-10">
                        <input type="email" className="form-control" id="emailRs" onChange={(e) => setemailRs(e.target.value)} value={emailRs} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="telpRs" className="col-sm-2 col-form-label required">Telepon</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="telpRs" onChange={(e) => settelpRs(e.target.value)} value={telpRs} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="website" className="col-sm-2 col-form-label">Website</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="website" onChange={(e) => setwebsite(e.target.value)} value={website} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="alamatRs" className="col-sm-2 col-form-label required">Alamat</label>
                    <div className="col-sm-10">
                        <textarea type="text" rows="3" className="form-control" id="alamatRs" onChange={(e) => setalamatRs(e.target.value)} value={alamatRs}></textarea>
                    </div>
                </div>
                <hr></hr>
                <div className="mb-5 row">
                    <div className='col-6'>
                        <span className="badge badge-info">Data Narahubung</span>
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="gender" className="col-sm-2 col-form-label required">Gender</label>
                    <div className="col-sm-10">
                        <select className='form-control' id='gender' onChange={(e) => setgender(e.target.value)} value={gender}>
                            <option value=''>- Pilih -</option>
                            <option value='Pria'>Pria</option>
                            <option value='Wanita'>Wanita</option>
                        </select>
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="namaDepan" className="col-sm-2 col-form-label required">Nama Depan</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="namaDepan" onChange={(e) => setnamaDepan(e.target.value)} value={namaDepan} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="namaBelakang" className="col-sm-2 col-form-label required">Nama Belakang</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="namaBelakang" onChange={(e) => setnamaBelakang(e.target.value)} value={namaBelakang} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="namaPanggilan" className="col-sm-2 col-form-label required">Nama Panggilan</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="namaPanggilan" onChange={(e) => setnamaPanggilan(e.target.value)} value={namaPanggilan} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="emailPic" className="col-sm-2 col-form-label required">Email</label>
                    <div className="col-sm-10">
                        <input type="email" className="form-control" id="emailPic" onChange={(e) => setemailPic(e.target.value)} value={emailPic} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="hp1" className="col-sm-2 col-form-label required">Nomor HP 1</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="hp1" onChange={(e) => sethp1(e.target.value)} value={hp1} />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="hp2" className="col-sm-2 col-form-label">Nomor HP 2</label>
                    <div className="col-sm-10">
                        <input type="text" className="form-control" id="hp2" onChange={(e) => sethp2(e.target.value)} value={hp2} />
                    </div>
                </div>
                <div className="mt-10 mb-5 row">
                    <div className="col-12">
                        <Button variant="danger" size="sm" onClick={() => props.close()}>
                            Tutup
                        </Button>
                        &nbsp;
                        <Button disabled={disabled} variant="success" size="sm" onClick={() => handleSubmit()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
                    </div>
                </div>
            </>
        </>
    )
}

export default FormVerificationManual
